"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartingModule = void 0;
const tslib_1 = require("tslib");
const AdaptableModuleBase_1 = require("./AdaptableModuleBase");
const ModuleConstants = tslib_1.__importStar(require("../Utilities/Constants/ModuleConstants"));
const ShowChartButton_1 = require("../View/Charting/ShowChartButton");
const ChartingWizard_1 = require("../View/Charting/ChartingWizard");
const ChartingRedux = tslib_1.__importStar(require("../Redux/ActionsReducers/ChartingRedux"));
const ChartingStatusBarPopover_1 = require("../View/Charting/ChartingStatusBarPopover");
const getObjectTagsViewItems_1 = require("./Utilities/getObjectTagsViewItems");
const ChartingState_1 = require("../PredefinedConfig/ChartingState");
class ChartingModule extends AdaptableModuleBase_1.AdaptableModuleBase {
    constructor(api) {
        super(ModuleConstants.ChartingModuleId, ModuleConstants.ChartingFriendlyName, 'chart', 'ChartPopup', 'Create AG Grid Charts in order to see Adaptable Data visually', api);
    }
    updateOldConfig() {
        const allChartDefinitions = this.api.chartingApi.getChartDefinitions();
        const chartDefinitionsToUpdate = allChartDefinitions
            .filter((chartDefinition) => 'model' in chartDefinition || !('Name' in chartDefinition))
            .map((charDefinition) => {
            const newChartDefinition = Object.assign({}, charDefinition);
            if ('model' in newChartDefinition) {
                newChartDefinition.Model = charDefinition.model;
                delete newChartDefinition.model;
            }
            if (!('Name' in newChartDefinition)) {
                // default to chartId
                // @ts-ignore possible because First iteration had no 'Name' and model was under 'model' key (lowercase)
                newChartDefinition.Name = newChartDefinition.Model.chartId;
            }
            return newChartDefinition;
        });
        if (chartDefinitionsToUpdate.length > 0) {
            chartDefinitionsToUpdate.forEach((chartDefinition) => this.api.chartingApi.editChartDefinition(chartDefinition));
        }
    }
    isModuleAvailable() {
        const agChartsAvailable = this.api.chartingApi.isChartingEnabled() && super.isModuleAvailable();
        const externalChartsAvailable = this.api.optionsApi.getChartingOptions().externalChartingOptions;
        return Boolean(agChartsAvailable || externalChartsAvailable);
    }
    getModuleAdaptableObjects() {
        return [
            ...this.api.chartingApi.getChartDefinitions(),
            ...this.api.chartingApi.getExternalChartDefinitions(),
        ];
    }
    toViewAll() {
        return this.getModuleAdaptableObjects().map((chartDef) => this.toView(chartDef));
    }
    toView(chart) {
        if ((0, ChartingState_1.isExternalChartDefinition)(chart)) {
            return this.toViewExternalChartDefinition(chart);
        }
        else {
            return this.toViewChartDefinition(chart);
        }
    }
    toViewExternalChartDefinition(chart) {
        return {
            items: [{ name: 'Name', values: [chart.Name] }],
            abObject: chart,
        };
    }
    toViewChartDefinition(chart) {
        var _a;
        return {
            items: [
                {
                    name: 'Name',
                    values: [chart.Name],
                },
                {
                    name: 'About',
                    values: [
                        `Chart Type: ${chart.Model.chartType}`,
                        chart.Model.aggFunc && `Aggregation Function: ${chart.Model.aggFunc}`,
                    ].filter(Boolean),
                },
                {
                    name: 'Settings',
                    values: [
                        `Unlink from data: ${chart.Model.unlinkChart ? 'Yes' : 'No'}`,
                        `Suppress Chart Ranges: ${chart.Model.suppressChartRanges ? 'Yes' : 'No'}`,
                    ],
                },
                {
                    name: 'Range',
                    values: [
                        `Row start index: ${chart.Model.cellRange.rowStartIndex}`,
                        `Row end index: ${chart.Model.cellRange.rowEndIndex}`,
                        chart.Model.cellRange.columnStart &&
                            `Column start: ${typeof chart.Model.cellRange.columnStart === 'string'
                                ? this.api.columnApi.getFriendlyNameForColumnId(chart.Model.cellRange.columnStart)
                                : this.api.columnApi.getFriendlyNameForColumnId(chart.Model.cellRange.columnStart.getColId())}`,
                        chart.Model.cellRange.columnEnd &&
                            `Column start: ${typeof chart.Model.cellRange.columnEnd === 'string'
                                ? this.api.columnApi.getFriendlyNameForColumnId(chart.Model.cellRange.columnEnd)
                                : this.api.columnApi.getFriendlyNameForColumnId(chart.Model.cellRange.columnEnd.getColId())}`,
                        ((_a = chart.Model.cellRange.columns) === null || _a === void 0 ? void 0 : _a.length) &&
                            `Columns ${chart.Model.cellRange.columns
                                .map((column) => typeof column === 'string'
                                ? this.api.columnApi.getFriendlyNameForColumnId(column)
                                : this.api.columnApi.getFriendlyNameForColumnId(column.getColId()))
                                .join(', ')}`,
                    ].filter(Boolean),
                },
                (0, getObjectTagsViewItems_1.getObjectTagsViewItems)(chart, this.api),
            ].filter(Boolean),
            abObject: chart,
        };
    }
    getViewProperties() {
        return {
            actions: [ShowChartButton_1.ShowChartButton],
            getEditWizard: () => ChartingWizard_1.ChartingWizard,
            // not sure if charts should be created via adaptable wizard
            hideNewButton: true,
            getDeleteAction: (chartDefinition) => {
                return (0, ChartingState_1.isAgChartDefinition)(chartDefinition)
                    ? ChartingRedux.ChartingDeleteChart(chartDefinition)
                    : ChartingRedux.ChartingDeleteExternalChart(chartDefinition);
            },
            emptyView: 'To create a chart select a few cells and right click. Then select "Chart Range" from the context menu.',
            getStatusBarPanelProps: () => {
                const content = ChartingStatusBarPopover_1.ChartingStatusBarPopover;
                return {
                    content,
                    triggerActionOnWrapperClick: false,
                };
            },
        };
    }
}
exports.ChartingModule = ChartingModule;
